/** @jsxImportSource @emotion/react */
import bannerDesktop from "@/assets/img/banner-8-desktop.png";
import bannerMobile from "@/assets/img/banner-8-mobile.png";
import NovaventaButton from "@/components/formControls/button/NovaventaButton";
import NovaventaRadio from "@/components/formControls/radio/NovaventaRadio";
import InformationBox from "@/components/InformationBox/InformationBox";
import ModalMessage from "@/components/ModalMessage";
import QuitRegistration from "@/components/QuitProcess";
import { usePrismic } from "@/hooks/usePrismic";
import { chatBot } from "@/libs/chatBot";
import {
  sendUserPaymentMethod,
  validateTransUnion
} from "@/services/paymentMethodServices";
import { getObject, removeObject, setObject } from "@/utils/hooks/localStorage";
import { capitalizaFirstLetter } from "@/utils/utils";
import { Col, Form, Row } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { style } from "./style";

export const PaymentMethod = () => {
  const t = usePrismic();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [paymentMethod, setPaymentMethod] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalKindText, setModalKindText] = useState("");
  const [modalBtnText, setModalBtnText] = useState("");
  const [modalAlertText, setModalAlertText] = useState("");
  const [modalTextModal, setModalTextModal] = useState("");

  const name = capitalizaFirstLetter(getObject("name") ?? "");

  const onPaymentMethodChange = (ev: any) => {
    setPaymentMethod(ev.target.value);
  };

  useEffect(() => {
    chatBot.setChatVariable("seccion", "4");
  });

  const onFinish = (values: any) => {
    if (values.PaymentMethod === "CO") {
      const postData = {
        estado: values.PaymentMethod
      };
      setObject("PaymentMethod", values.PaymentMethod);
      submitUserPaymentMethod(postData);
    } else {
      const idNumber = getObject("idNumber");
      const uuid = getObject("uuid");
      validateTransUnion(idNumber)
        .then(({ data }) => {
          if (data.continuar) {
            const baseURL = process.env.REACT_APP_API_URL;
            window.location.assign(`${baseURL}/redireccionar/${uuid}`);
          } else {
            if (data.codigo === "E-17") {
              setModalTextModal(t.errors["MSGE-17"]);
              setModalAlertText(t.errors["ARTE-17"]);
              setModalBtnText(t.errors["BTNE-17"]);
              setModalKindText(t.errors["KNDE-17"]);
              setShowModal(true);
            }
            const postData = {
              estado: "CO"
            };
            setObject("PaymentMethod", "CO");
            submitUserPaymentMethod(postData);
          }
        })
        .catch(console.error);
    }
  };

  const submitUserPaymentMethod = (values: any) => {
    sendUserPaymentMethod(values)
      .then(({ data }) => {
        if (data?.continuar) {
          navigate("../bienvenida");
          removeObject("uuid");
        } else {
          onHandleError(t.constants.LOSENTIMOSERROR);
        }
      })
      .catch(onHandleError);

    form.resetFields();
  };

  const onHandleError = (error: unknown) => {
    setErrorMessage(String(error));
    setShowError(true);
  };

  return (
    <Row css={style}>
      <Col xs={24} lg={0}>
        <img src={bannerMobile} alt="bannerMobile" width="640" height="235" />
      </Col>
      <Col xs={0} lg={7}>
        <img src={bannerDesktop} alt="bannerDesktop" width="962" height="553" />
      </Col>
      <Col xs={24} lg={17}>
        <Form
          form={form}
          id="methodOfPayment"
          data-testid="methodOfPayment"
          name="methodOfPayment"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={console.error}
          onValuesChange={() => setShowError(false)}
        >
          <Row justify="center">
            <Col xs={24} sm={18}>
              <h1>
                {t.constants.HOLA}
                <b>{name}</b>
              </h1>
              <p>
                {t.constants.YAERES}
                <b>{t.constants.MAMAEMPRE}</b>
                {t.constants.YPUEDES}
                <b>{t.constants.NOVAVENTA}</b>
                {t.constants.TENEMOSPARATI}
              </p>
              <p>{t.constants.CUPODECREDITO}</p>
              <h3>{t.constants.DESEASOLICITAR}</h3>
            </Col>
            <Col xs={24} sm={18}>
              <Form.Item
                name="PaymentMethod"
                rules={[
                  {
                    required: true,
                    message: t.home.rules.PaymentMethod
                  }
                ]}
              >
                <NovaventaRadio
                  options={t.options.paymentMethod}
                  onChange={onPaymentMethodChange}
                  value={paymentMethod}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={18}>
              <InformationBox hide={showError} text={errorMessage} kind={"error"} />
            </Col>
          </Row>
          <Row justify="space-evenly" align="stretch">
            <Col xs={20} sm={13} md={11} lg={9} xl={7}>
              <NovaventaButton showArrow={true} htmlType="submit" />
            </Col>
            <Col xs={20} sm={13} md={11} lg={9} xl={7}>
              <QuitRegistration />
            </Col>
          </Row>
        </Form>
      </Col>
      <ModalMessage
        showModal={showModal}
        text={modalTextModal}
        alertText={modalAlertText}
        btnText={modalBtnText}
        kind={modalKindText}
      />
    </Row>
  );
};
